export const actionTypes = {
    PrintData: "[Print Data] Action",
    WinningPaid: "[Winning paid] Action",
    CancelTicket: "[Cancel Ticket] Action",
    SetPrintType: "[Set Print Type] Action",
    ScanInput: "[Scan Input] Action",
    AfterPrintTrigger: "[After print trigger] Action"
};

const initialState = {
    printData: {},
    isWinningPaid: false,
    isCancelled: false,
    printType: 0,
    canFocusScanInput: true,
    afterPrintTrigger: false
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PrintData : {
            const { printData } = action.payload;
            return {
                ...state,
                printData,
            }
        }
        case actionTypes.WinningPaid: {
            const {value} = action.payload;

            const isWinningPaid = typeof value !== "undefined" ? value : false;

            return {
                ...state,
                isWinningPaid
            }
        }
        case actionTypes.CancelTicket: {

            return {
                ...state, printData: {...state.printData, statusId: 4}
            }
        }
        case actionTypes.SetPrintType: {
            const {id} = action.payload;

            return {
                ...state, printType: id
            }
        }
        case actionTypes.ScanInput: {
            const {canFocusScanInput} = action.payload;

            return {
                ...state, canFocusScanInput
            }
        }
        case actionTypes.AfterPrintTrigger: {
            return {
                ...state, afterPrintTrigger: !state.afterPrintTrigger
            }
        }
        default: {
            return state
        }
    }
}

export const actions = {
    setPrintData : (printData = {}) => ({
        type: actionTypes.PrintData,
        payload: {printData}
    }),
    setWinningPaid: (value) => ({
        type: actionTypes.WinningPaid,
        payload: {value}
    }),
    setTicketAsCancelled: (value) => ({
        type: actionTypes.CancelTicket,
        payload: {value}
    }),
    setPrintType: (id) => ({
        type: actionTypes.SetPrintType,
        payload: {id}
    }),
    setCanFocusScanInput: (canFocusScanInput) => ({
        type: actionTypes.ScanInput,
        payload: {canFocusScanInput}
    }),
    afterPrintTrigger: () => ({
        type: actionTypes.AfterPrintTrigger
    })
}